// ============================================================
// Fee Structure Items API
// ============================================================

import client from './axios';

export const feeStructureItemsApi = {
  /**
   * Get all items/components for a specific fee structure
   */
  getItems: async (feeStructureId) => {
    const response = await client.get(`/fee-structure-items/fee-structures/${feeStructureId}/items`);
    return response.data;
  },

  /**
   * Create a new fee structure item/component
   */
  createItem: async (feeStructureId, payload) => {
    const response = await client.post(
      `/fee-structure-items/fee-structures/${feeStructureId}/items`,
      payload
    );
    return response.data;
  },

  /**
   * Update an existing fee structure item
   */
  updateItem: async (itemId, payload) => {
    const response = await client.put(`/fee-structure-items/${itemId}`, payload);
    return response.data;
  },

  /**
   * Delete a fee structure item
   */
  deleteItem: async (itemId) => {
    const response = await client.delete(`/fee-structure-items/${itemId}`);
    return response.data;
  },
};
